import { makeQuery } from "api/api";
import { UserSchema } from "model/user/schema";
import { ApiEndpoints } from "api/endpoints";

export const fetchUserOne = async (id: number) => {
  const response = await makeQuery(ApiEndpoints.userOne(id), true);
  return UserSchema.parse(response.data);
};
